import React from "react";

import toast from "react-hot-toast";
import { connect } from "react-redux";
import {
  setCartAddedAddons,
  setCartJobItems,
  setCartProducts,
} from "../../../../redux/actions/cartAction";

const SelectedAddonItem = ({ addon, cart, setCartAddedAddons, index }) => {
  let { stage, products, jobItems, addons, addedAddons } = cart;
  const checkAdded =
    addedAddons.filter((res) => res.Id == addon.Id).length === 1;

  const handleAddAddon = () => {
    // const result = addedAddons.filter((res) => res.Id == addon.Id);
    if (!checkAdded) {
      setCartAddedAddons([...addedAddons, addon]);
      // setAddons([...addon, e])
    } else {
      toast.dismiss();
      toast.error("Already Added!");
      // alert('already added')
    }
  };

  const handleRemoveAddon = () => {
    // const result = addedAddons.filter((res) => res.Id == addon.Id);
    if (checkAdded) {
      let remainingAddons = addedAddons.filter((item) => item.Id !== addon.Id);
      setCartAddedAddons(remainingAddons);
      // setAddons([...addon, e])
    } else {
      toast.dismiss();
      toast.error("Already Added!");
      // alert('already added')
    }
  };

  return (
    <div className="workshop-bar p-0 border-none w-100 px-1">
      <div className="cart-list-addons d-flex justify-content-between align-items-center p-2 w-100">
        <img
          src={addon.ImgUrl}
          alt="addon"
          width={35}
          style={{ borderRadius: "10px", objectFit: "cover" }}
        />
        <div className="d-flex align-items-center justify-content-between px-2 w-100">
          <div className="mx-2">
            <h6 className="mb-1 text-capitalize font-weight-bold smtxt-dladon">
              {addon.Name}
            </h6>
            <p
              className="text-dark font-weight-bold"
              style={{ fontSize: "12px", lineHeight: "16px" }}
            >
              {/* AED {addon.Cost} */}
              {addon.Cost > 0 && (
                <span
                  className="font-weight-bold"
                  style={{ color: "#000", fontSize: 12, width: "75px" }}
                >
                  AED {addon.Cost}
                </span>
              )}
              {addon.IsFree && (
                <span
                  className="font-weight-bold text-center"
                  style={{ color: "#28a745", fontSize: 12, width: "75px" }}
                >
                  Free
                </span>
              )}
              {addon.IsEstimate && (
                <span
                  className="font-weight-bold text-center"
                  style={{ color: "#0451be", fontSize: 12, width: "75px" }}
                >
                  Get Cost
                </span>
              )}
            </p>
          </div>
          {/* <div className="d-flex align-items-center justify-content-between text-right">
            {addon.Cost > 0 ? (
              <span
                className="font-weight-bold"
                style={{ color: "#FF0000", fontSize: 12, width: "75px" }}
              >
                {`+ AED ${addon.Cost}`}
              </span>
            ) : (
              <span
                className="font-weight-bold text-center"
                style={{ color: "#28a745", fontSize: 12, width: "75px" }}
              >
                Free
              </span>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (jobs) => {
      dispatch(setCartJobItems(jobs));
    },
    setCartAddedAddons: (addons) => {
      dispatch(setCartAddedAddons(addons));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedAddonItem);
